import { ComedianWithImageUrl } from "./types";
import SuggestedComedianCard from "./cards/SuggestedComedianCard";
import SuggestedComediansCarousel from "./SuggestedComediansCarousel";

interface SuggestedComediansProps {
  comedians: ComedianWithImageUrl[];
  isLoggedOutState: boolean;
  hideEnabled: boolean;
  onHide: (comedianId: string) => void;
}

export default function SuggestedComedians({
  comedians,
  isLoggedOutState,
  hideEnabled,
  onHide,
}: SuggestedComediansProps) {
  return (
    <SuggestedComediansCarousel
      title="Artists you might like"
      location="feed"
      slides={comedians.map((comedian) => ({
        id: comedian.display_name ?? "",
        Component: (
          <SuggestedComedianCard
            isLoggedOutState={isLoggedOutState}
            comedian={comedian}
            hideEnabled={hideEnabled}
            onHide={onHide}
          />
        ),
      }))}
    />
  );
}
